import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { getPendingSlots, destroyContributionsForSlot } from '../../../api/ContributionsAPI';
import AppPaginator from '../../AppPaginator';
import AppSearchBox from '../../AppSearchBox'; // --- 1. IMPORT AppSearchBox ---
import { Can } from '../../../hooks/usePermissions';

const ContributionsList = () => {
    const navigate = useNavigate();
    const [slotsList, setSlotsList] = useState({ data: [], last_page: 0 });
    const [isLoading, setIsLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [triggerFetch, setTriggerFetch] = useState(false);

    // --- 2. ADD STATE FOR SEARCH ---
    const [searchTerm, setSearchTerm] = useState('');
    const [searchTermCompleted, setSearchTermCompleted] = useState('');

    useEffect(() => {
        setIsLoading(true);
        // --- 3. ADD SEARCH TERM TO FILTERS ---
        const filters = { 
            page: currentPage, 
            search_term: searchTermCompleted 
        };
        getPendingSlots(filters, (response) => {
            setIsLoading(false);
            if (response.booking_slots) {
                setSlotsList(response.booking_slots);
            }
        });
    }, [currentPage, triggerFetch, searchTermCompleted]); // --- 4. ADD searchTermCompleted to dependency array ---

    const handleGenerateClick = (slotId) => navigate(`/club_portal/contributions/create/${slotId}`);
    const handleEditClick = (slotId) => navigate(`/club_portal/contributions/edit/${slotId}`);
    const handleViewStatementClick = (slotId) => navigate(`/club_portal/contributions/statement/${slotId}`);
   // --- FULL handleDeleteClick IMPLEMENTATION ---
    const handleDeleteClick = (slot) => {
        Swal.fire({
            title: 'Are you sure?',
            html: `This will delete all contributions for the booking slot on <strong>${slot.slot_date}</strong>. This action cannot be undone.`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, delete them!'
        }).then((result) => {
            if (result.isConfirmed) {
                // Call the API function to delete
                destroyContributionsForSlot(slot.id, (res) => {
                    if (res.success) {
                        Swal.fire('Deleted!', 'All contributions for this slot have been deleted.', 'success');
                        // Refresh the list after deletion
                        setTriggerFetch(p => !p);
                    } else {
                        Swal.fire('Error!', 'Could not delete contributions.', 'error');
                    }
                });
            }
        });
    };

    return (
        <div className="card">
            {/* --- 5. UPDATE CARD HEADER TO INCLUDE SEARCH BOX --- */}
            <div className="card-header d-flex justify-content-between align-items-center">
                <div>
                    <h5>Booking Slots</h5>
                    <small className="text-muted">view financial contributions for each playing session.</small>
                </div>
                <div style={{ minWidth: '250px' }}>
                    <AppSearchBox 
                        searchTerm={searchTerm} 
                        setSearchTerm={setSearchTerm} 
                        setSearchTermCompleted={setSearchTermCompleted} 
                    />
                </div>
            </div>
            <div className="card-body">
                {isLoading ? (
                    <div className="text-center"><div className="spinner-border"></div></div>
                ) : slotsList.data.length > 0 ? (
                    <div className="table-responsive">
                        <table className="table table-hover">
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Time</th>
                                    <th>Venue</th>
                                    <th>Cost</th>
                                    <th>Status</th>
                                    <th>Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                {slotsList.data.map(slot => (
                                    <tr key={slot.id}>
                                        <td>{slot.slot_date}</td>
                                        <td>{slot.start_time} - {slot.end_time}</td>
                                        <td>{slot.turf_booking.venue.name}</td>
                                        <td>₹{slot.cost}</td>
                                        <td>
                                            {slot.contributions_count > 0
                                                ? <span className="badge bg-success">Generated</span>
                                                : <span className="badge bg-warning text-dark">Pending</span>
                                            }
                                        </td>
                                        <td>
                                            {slot.contributions_count > 0 ? (
                                                <>
                                                    <button className="btn btn-outline-secondary btn-sm me-2" onClick={() => handleViewStatementClick(slot.id)}>View Statement</button>
                                                    <Can any={['edit-contributions']}>
                                                    <button className="btn btn-outline-primary btn-sm me-2" onClick={() => handleEditClick(slot.id)}>Edit</button>
                                                    </Can>
                                                     <Can any={['delete-contributions']}>
                                                    <button className="btn btn-outline-danger btn-sm" onClick={() => handleDeleteClick(slot)}>Delete</button>
                                                    </Can>
                                                </>
                                            ) : (
                                                <button className="btn btn-primary btn-sm" onClick={() => handleGenerateClick(slot.id)}>Generate</button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                ) : (
                    <p className="text-center">No booking slots found for the current criteria.</p>
                )}
                <AppPaginator totalPages={slotsList.last_page} currentPage={currentPage} setCurrentPage={setCurrentPage} />
            </div>
        </div>
    );
};

export default ContributionsList;